import { string } from 'yup'

export default string().required().max(200, 'First name can be more than 200 characters')
